import { query } from '@confluence/query-preloader-tools/entry-points/graphql';
import { getOnboardingStateGQL } from '@confluence/onboarding-helpers/entry-points/getOnboardingStateGQL';
import {
	ONBOARDING_EXPERIENCES,
	OPTIONAL_NTH_USER_GUIDED_TOUR_ONBOARDING_STATE_KEYS,
} from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants';

export async function preloadOptionalNthUserGuidedTour() {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: getOnboardingStateGQL,
		variables: {
			key: [
				ONBOARDING_EXPERIENCES.IS_FOUNDING_ADMIN,
				...Object.values(OPTIONAL_NTH_USER_GUIDED_TOUR_ONBOARDING_STATE_KEYS),
			],
		},
	});
}
